import { Box, TextField } from "@mui/material";
import React from "react";

export default function RequireField({
  value,
  onChange,
  type,
  inputProps,
  disabled,
  error,
  setError,
  textError,
  placeholder,
}) {
  return (
    <>
      <Box className={`backgroundField ${error ? "error" : ""}`}>
        <TextField
          value={value}
          onChange={(e) => onChange(e.target.value)}
          variant="standard"
          fullWidth
          placeholder={placeholder || ''}
          onBlur={(e) => {
            if (!e.target.value) {
              setError(true);
            } else {
              setError(false);
            }
          }}
          InputProps={{
            disableUnderline: true,
          }}
          inputProps={inputProps}
          disabled={disabled}
          onKeyPress={(event) => {
            if (type === "number") {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }
          }}
        />
      </Box>
      {error && (
        <span style={{ color: "red", fontSize: "12px" }}>{textError}</span>
      )}
    </>
  );
}
